import { render, staticRenderFns } from "./Christmas.vue?vue&type=template&id=37fb301a&scoped=true&"
import script from "./Christmas.vue?vue&type=script&lang=js&"
export * from "./Christmas.vue?vue&type=script&lang=js&"
import style0 from "./Christmas.vue?vue&type=style&index=0&id=37fb301a&scoped=true&lang=scss&"
import style1 from "./Christmas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb301a",
  null
  
)

export default component.exports